// Sticky Ads in Blog Sidebar (Desktop Only)
document.addEventListener('DOMContentLoaded', function() {
  // Only run on desktop
  const isDesktop = window.innerWidth >= 1024; // Adjust breakpoint as needed
  
  if (!isDesktop) return;
  
  const stickyElements = document.querySelectorAll('[data-sticky-ads]');
  
  // Let's try to measure the header height more accurately
  function getHeaderHeight() {
    // Try different selectors that might match your header
    const headerSelectors = [
      'header.site-header', 
      '.header-wrapper',
      '.header-container',
      '.main-header',
      'header.header',
      'header',
      '#shopify-section-header'
    ];
    
    let headerHeight = 0;
    
    // Try each selector
    for (const selector of headerSelectors) {
      const header = document.querySelector(selector);
      if (header) {
        headerHeight = header.offsetHeight;
        console.log('Found header with selector:', selector, 'Height:', headerHeight);
        break;
      }
    }
    
    // If we still don't have a height, use a safe default
    if (headerHeight === 0) {
      headerHeight = 80; // Default fallback header height
      console.log('Using default header height:', headerHeight);
    }
    
    return headerHeight;
  }
  
  // Get the header height
  const headerOffset = getHeaderHeight() + 20; // Add 20px extra spacing
  console.log('Final header offset being used:', headerOffset);
  
  stickyElements.forEach(element => {
    // Store original position
    const parent = element.closest('.m-widget--sticky');
    let originalTop = 0;
    let parentOffsetTop = 0;
    let sidebarHeight = 0;
    let elementHeight = 0;
    let ticking = false;
    
    function updateDimensions() {
      if (parent) {
        parentOffsetTop = parent.getBoundingClientRect().top + window.scrollY;
        originalTop = parentOffsetTop;
        elementHeight = element.offsetHeight;
        sidebarHeight = parent.parentNode.offsetHeight;
        console.log('Original top position:', originalTop);
      }
    }
    
    // Initialize dimensions
    updateDimensions();
    
    // Handle resize
    window.addEventListener('resize', function() {
      if (window.innerWidth >= 1024) {
        updateDimensions();
      } else {
        // Reset styles if viewport becomes mobile
        element.style.position = '';
        element.style.top = '';
        element.style.width = '';
      }
    });
    
    // Scroll handler
    window.addEventListener('scroll', function() {
      if (!ticking && window.innerWidth >= 1024) {
        window.requestAnimationFrame(function() {
          const scrollY = window.scrollY;
          const maxScroll = parentOffsetTop + sidebarHeight - elementHeight;
          
          // When scrolling down
          if (scrollY > originalTop - headerOffset + 20) {
            element.style.position = 'fixed';
            element.style.top = headerOffset + 'px'; // Use our calculated header offset
            element.style.width = parent.offsetWidth + 'px';
            
            // Stop at the bottom of the sidebar
            if (scrollY > maxScroll - headerOffset) {
              element.style.position = 'absolute';
              element.style.top = (maxScroll - parentOffsetTop) + 'px';
            }
          } 
          // When scrolling back up
          else {
            element.style.position = '';
            element.style.top = '';
            element.style.width = '';
          }
          
          ticking = false;
        });
        
        ticking = true;
      }
    });
  });
});